import { Component, OnInit } from '@angular/core';



@Component({

  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css']
})

export class AppComponent implements OnInit {
  
  title = 'my-portfolio';
  start: boolean = false
  start2: boolean = false
  start3: boolean = false
  start4: boolean = false
  start5: boolean = false
  start6: boolean = false
  start7: boolean = false
  start8: boolean = false
  start9: boolean = false
  start10: boolean = false
  start11: boolean = false
  start12: boolean = false
  start13: boolean = false
  start14: boolean = false
  start15: boolean = false
  start16: boolean = false
  start17: boolean = false
  start18: boolean = false
  start19: boolean = false
  start19After: boolean = false
  start20: boolean = false
  start21: boolean = false
  start21After: boolean =false;
  start22: boolean = false
  start23: boolean = false
  start24: boolean = false
  start25: boolean = false
  start26: boolean = false
  start27: boolean = false
  start28: boolean = false
  startmiddle: boolean = false
  startmiddle2: boolean = false
  startmiddle3: boolean = false
  stringInterpolation: string = "Angular 4 Typing Animation Directive (string interpolation)"
    
  delay(ms: number) {
    return new Promise( resolve => setTimeout(resolve, ms) );
}
  ngOnInit () {
    // Start after 1 second + 1 second of startDelay
    this.start = true;
    
  }

  onTypingAnimationComplete1 () {
    this.start2 = true;
    
    
    return true;
    // ...
  }
  onTypingAnimationComplete2 () {
    
    (async () => { 
      // Do something before delay
  
      await this.delay(1000);
  
      // Do something after
      this.start3 = true;
  })();
    
    // ...
  }
  onTypingAnimationComplete3 () {
    this.start4 = true;
    return true;
    
    // ...
  }
  scrollWin() {
    // window.scrollBy(0, 1500);
    window.scrollTo(0,document.body.scrollHeight);
    return true;
  }
  onTypingAnimationComplete4 () {
    this.start5 = true;
    
    // window.scrollBy(0,600); 
    return true;
    // ...
  }
  onTypingAnimationComplete5 () {
    
    this.start6=true;
    // ...
  }
  onTypingAnimationComplete6 () {
    
    this.start7=true;
    // ...
  }
  onTypingAnimationComplete7 () {
    
    this.start8=true;
    return true;
    // ...
  }
  onTypingAnimationComplete8 () {
    
    this.start9=true;
    return true;
    // ...
  }
  onTypingAnimationComplete9 () {
    
    (async () => { 
      // Do something before delay
  
      await this.delay(1000);
  
      // Do something after
      this.start10 = true;
      return true;
  })();
    
    // ...
  }
  onTypingAnimationComplete10 () {
    
    this.start11=true;
    return true;
    // ...
  }
  onTypingAnimationComplete11 () {
    
    this.start12=true;
    return true;
    // ...
  }
  onTypingAnimationComplete12 () {
    
    this.start13=true;
    return true;
    // ...
  }
  onTypingAnimationComplete13 () {
    
    this.start14=true;
    return true;
    // ...
  }
  onTypingAnimationComplete14 () {
    
    this.start15=true;
    return true;
    // ...
  }
  onTypingAnimationComplete15 () {
    
  //   (async () => { 
  //     // Do something before delay
  
  //     await this.delay(1000);
  
  //     // Do something after
  //     this.start16 = true;
  //     return true;
  // })();
    // ...
    this.start16 = true;
      return true;
  }
  onTypingAnimationComplete16 () {
    
    this.start17=true;
    return true;
    // ...
  }
  onTypingAnimationComplete17 () {
    
    this.start18=true;
    return true;
    // ...
  }
  onTypingAnimationComplete18 () {
    
    this.start19=true;
    return true;
    // ...
  }
  onTypingAnimationComplete19 () {
    
    this.start19After=true;
    return true;
    // ...
  }
  onTypingAnimationComplete19After () {
    
    this.start20=true;
    return true;
    // ...
  }
  onTypingAnimationComplete20 () {
    
    this.start21=true;
    return true;
    // ...
  }
  onTypingAnimationComplete21After () {
    
    this.start22=true;
    return true;
    // ...
  }
  onTypingAnimationComplete21 () {
    
    this.start21After=true;
    return true;
    // ...
  }
  onTypingAnimationComplete22 () {
    
    this.start23=true;
    return true;
    // ...
  }
  onTypingAnimationComplete23 () {
    
    this.start24=true;
    // console.log("24 started")
    return true;
    // ...
  }
  onTypingAnimationComplete24 () {
    
  //   (async () => { 
  //     // Do something before delay
  
  //     await this.delay(1000);
  
  //     // Do something after
  //     this.start25 = true;
  //     return true;
  // })();
  // console.log("25  started")
  this.start25 = true;
  return true;
    // ...
  }
  onTypingAnimationComplete25 () {
    
    this.start26=true;
    return true;
    // ...
  }
  onTypingAnimationComplete26 () {
    
    this.start27=true;
    return true;
    // ...
  }
  onTypingAnimationComplete27 () {
    
    this.start28=true;
    return true;
    // ...
  }
  onTypingAnimationCompletemiddle(){
    ;
    this.startmiddle=true;
    return true;
  }
  onTypingAnimationCompletemiddle2(){
    
    this.startmiddle2=true;
    return true;
    
  }
  onTypingAnimationCompleteMiddle2(){

    this.startmiddle3=true;
    return true;
  }
  
}
